import React from 'react';
import { motion } from 'framer-motion';
import styles from './GamesLink.module.css';

const GamesLink: React.FC = () => {
  return (
    <section className={styles.gamesLink}>
      <div className="container">
        <motion.div
          className={styles.gamesLinkWrapper}
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <div className={styles.gamesLinkContent}>
            <div className={styles.gamesText}>
              <h3 className={styles.gamesTitle}>We Also Build Games</h3>
              <p className={styles.gamesDescription}>
                Explore our collection of interactive games and gaming experiences at <strong>jagoaltgames.com</strong>
              </p>
            </div>
            <motion.a
              href="https://jagoaltgames.com"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.gamesButton}
              whileHover={{ scale: 1.05, x: 5 }}
              whileTap={{ scale: 0.95 }}
            >
              Visit jagoaltgames.com
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M7 17L17 7M17 7H7M17 7V17"/>
              </svg>
            </motion.a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default GamesLink;
